import svgPaths from "./svg-joy4njkm5x";
import imgImage521 from "../../../assets/web-v3-images/2b95eabc35cc72be0b91a0d1a96588f6c6943ed4.png";
import imgImage468 from "../../../assets/web-v3-images/d5b9f89152c98a83798407b4d6744802caa5d553.png";
import imgImage524 from "../../../assets/web-v3-images/41541279f77f5941922228030afb10c5748f4d5c.png";
import imgImage387 from "../../../assets/web-v3-images/c7fdad3699c9f7fbf9531760c98ea32429be3a18.png";
import imgImage388 from "../../../assets/web-v3-images/b47741bad27ab0f27cde8e8002018ff420c68999.png";
import imgImage395 from "../../../assets/web-v3-images/c58162bf1f87c50f2ccdab620881c998af0d3e47.png";
import imgImage529 from "../../../assets/web-v3-images/31b698866a227005676d8bb79a0124204d98105f.png";
import imgImage441 from "../../../assets/web-v3-images/Frame_34158.png";
import imgImage362 from "@assets/web-v3-images/icons/shwe-hour-coin.png";
import Headers from "@/component/Headers";
import { useTranslation } from "react-i18next";
import { EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import { useState } from "react";
import { useNavigate } from "react-router";
import PATH from "@/config/PATH";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { CheckIcon, ChevronDownIcon } from "@radix-ui/react-icons";
import imgMM from "../../../assets/web-v3-images/icons/MM.png";
import imgUS from "../../../assets/web-v3-images/icons/US.png";
import { IS_UPDATE_VERSION_3_PROJECT } from "@/helper/const";
import { formatDataNumberToen } from '@/utils/helper';

function ContainerProfile() {
  return (
    <div className="-translate-x-1/2 absolute bottom-0 content-stretch flex flex-col items-start left-1/2 top-0 w-[816px]">
      <div
        className="aspect-[816/81] relative shrink-0 w-full"
        data-name="image 524"
      >
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <img
            alt=""
            className="absolute h-[767.97%] left-[-7.14%] max-w-none top-[-125.25%] w-[114.29%]"
            src={imgImage524}
          />
        </div>
      </div>
      <div
        className="flex-[1_0_0] min-h-px relative w-full"
        data-name="image 526"
      >
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <img
            alt=""
            className="absolute h-[272.83%] left-[-7.14%] max-w-none top-[-80.02%] w-[114.29%]"
            src={imgImage524}
          />
        </div>
      </div>
      <div
        className="aspect-[816/81] relative shrink-0 w-full"
        data-name="image 525"
      >
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <img
            alt=""
            className="absolute h-[767.97%] left-[-7.14%] max-w-none top-[-506.73%] w-[114.29%]"
            src={imgImage524}
          />
        </div>
      </div>
    </div>
  );
}

function ButtonPhoto({ handleOpenUpload }) {
  return (
    <div
      onClick={handleOpenUpload}
      className="absolute content-stretch drop-shadow-[0px_1.467px_1.467px_rgba(10,13,18,0.05)] flex items-center justify-center left-[149.6px] overflow-clip px-[11.733px] py-[20.533px] rounded-[14665.2px] size-[70.4px] top-[149.6px] btn-click-active"
      data-name="Buttons/Button"
    >
      <div className="absolute flex items-center justify-center left-[-4.4px] size-[79.2px] top-[-4.4px]">
        <div className="flex-none rotate-180">
          <div
            className="pointer-events-none relative size-[79.2px]"
            data-name="image 468"
          >
            <img
              alt=""
              className="absolute inset-0 max-w-none object-cover size-full"
              src={imgImage468}
            />
            <div className="absolute inset-0 rounded-[inherit] shadow-[inset_0px_0px_0px_0px_rgba(10,13,18,0.18),inset_0px_-2.933px_0px_0px_rgba(10,13,18,0.05)]" />
          </div>
        </div>
      </div>
      <div
        className="drop-shadow-[0px_1.467px_2.2px_rgba(10,13,18,0.1),0px_1.467px_1.467px_rgba(10,13,18,0.1)] relative shrink-0 size-[46.933px]"
        data-name="solar:camera-bold"
      >
        <div className="absolute inset-[12.5%_8.33%]" data-name="Vector">
          <svg
            className="absolute block inset-0 size-full"
            fill="none"
            preserveAspectRatio="none"
            viewBox="0 0 39.1111 35.2001"
          >
            <path
              clipRule="evenodd"
              d={svgPaths.p138a9e00}
              fill="var(--fill-0, #FFFAEB)"
              fillRule="evenodd"
              id="Vector"
            />
          </svg>
        </div>
      </div>
    </div>
  );
}

function Avatar({
  handlePreview,
  handleDelete = () => { },
  // setShowActions = () => {},
  // showActions = false,
  fileList,
  handleOpenUpload,
}) {
  const [showActions, setShowActions] = useState(false);
  return (
    <div className="relative shrink-0 size-[220px]">
      <div
        className="relative size-[220px]"
        onClick={() => setShowActions((prev) => !prev)}
      >
        <img
          src={fileList[0]?.url}
          alt=""
          className="size-full rounded-full object-cover"
        />

        <div
          className={`absolute inset-0 rounded-full bg-black/45 flex items-center justify-center gap-5
      transition-all duration-300
      ${showActions ? "opacity-100 visible" : "opacity-0 invisible"}`}
        >
          <button
            className="btn-click-active w-11 h-11 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center hover:bg-white/30 transition"
            onClick={(e) => {
              e.stopPropagation();
              handlePreview();
            }}
          >
            <EyeOutlined
              className="text-xl cursor-pointer"
              style={{ color: "white" }}
            />
          </button>

          <button
            className="btn-click-active w-11 h-11 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center hover:bg-red-500 transition"
            onClick={(e) => {
              e.stopPropagation();
              handleDelete();
            }}
          >
            <DeleteOutlined
              className="text-xl cursor-pointer text-red-500"
              style={{ color: "white" }}
            />
          </button>
        </div>
      </div>

      <ButtonPhoto handleOpenUpload={handleOpenUpload} />
    </div>
  );
}

function ProfileInfoHeader({ valueName, setOpenUpdateName }) {
  const { t } = useTranslation();

  return (
    <div
      onClick={() => setOpenUpdateName(true)}
      className="content-stretch flex gap-[16px] items-center relative shrink-0 w-full"
    >
      <p className="[word-break:break-word] flex-[1_0_0] font-['Inter:Bold',sans-serif] font-bold leading-none min-w-px not-italic relative text-[#713b12] text-[36px]">
        {valueName?.length > 20 ? valueName?.slice(0, 20) + "..." : valueName}
      </p>
      <div className="bg-[#fefdf0] content-stretch flex gap-[6px] items-center px-[12px] py-[8px] relative rounded-[99px] shrink-0 btn-click-active">
        <div
          aria-hidden
          className="absolute border border-[#f9dbaf] border-solid inset-0 pointer-events-none rounded-[99px]"
        />
        <div
          className="relative shrink-0 size-[32px]"
          data-name="solar:pen-2-bold"
        >
          <div
            className="absolute inset-[88.54%_13.54%_5.21%_13.54%]"
            data-name="Vector"
          >
            <svg
              className="absolute block inset-0 size-full"
              fill="none"
              preserveAspectRatio="none"
              viewBox="0 0 23.3333 2"
            >
              <path
                clipRule="evenodd"
                d={svgPaths.pf556880}
                fill="var(--fill-0, #E04F16)"
                fillRule="evenodd"
                id="Vector"
              />
            </svg>
          </div>
          <div
            className="absolute bottom-1/4 left-[16.66%] right-[16.67%] top-[8.33%]"
            data-name="Vector"
          >
            <svg
              className="absolute block inset-0 size-full"
              fill="none"
              preserveAspectRatio="none"
              viewBox="0 0 21.3346 21.334"
            >
              <path
                d={svgPaths.p1f4e1880}
                fill="var(--fill-0, #E04F16)"
                id="Vector"
              />
            </svg>
          </div>
        </div>
        <p className="[word-break:break-word] font-['Inter:Semi_Bold',sans-serif] font-semibold not-italic relative shrink-0 text-[#e04f16] text-[28px] whitespace-nowrap">
          {t("account_page.edit")}
        </p>
      </div>
    </div>
  );
}

function SDMaster({ isMaster }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div
      onClick={() => navigate(PATH.RANK)}
      className="content-stretch flex gap-[6px] items-center pl-[6px] pr-[16px] py-[4px] relative rounded-[99px] shrink-0 cursor-pointer"
      style={{
        backgroundImage:
          "linear-gradient(256.354deg, rgb(255, 247, 207) 5.2335%, rgb(255, 211, 140) 44.081%, rgb(255, 242, 182) 92.051%), linear-gradient(90deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 100%)",
      }}
    >
      <div
        aria-hidden
        className="absolute border border-[#fff0aa] border-solid inset-0 pointer-events-none rounded-[99px]"
      />
      <div className="relative shrink-0 size-[54px]" data-name="image 387">
        <div aria-hidden className="absolute inset-0 pointer-events-none">
          <img
            alt=""
            className="absolute max-w-none object-cover size-full"
            src={imgImage387}
          />
          {isMaster && (
            <div className="absolute inset-0 overflow-hidden">
              <img
                alt=""
                className="absolute left-[-8.33%] max-w-none size-[116.67%] top-[-8.33%]"
                src={imgImage388}
              />
            </div>
          )}
        </div>
      </div>
      <p className="[word-break:break-word] font-['Inter:Semi_Bold',sans-serif] font-semibold leading-none not-italic relative shrink-0 text-[#713b12] text-[28px] whitespace-nowrap">
        {isMaster ? "Shwe Master" : "Shwe Explorer"}
      </p>
      <div
        className="relative shrink-0 size-[28px]"
        data-name="solar:alt-arrow-right-linear"
      >
        <div className="absolute inset-[20.83%_37.5%]" data-name="Vector">
          <div className="absolute inset-[-9.18%_-21.43%]">
            <svg
              className="block size-full"
              fill="none"
              preserveAspectRatio="none"
              viewBox="0 0 10 19.3334"
            >
              <path
                d={svgPaths.p5ed6c80}
                id="Vector"
                stroke="var(--stroke-0, #A15C07)"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}

function ProfilePhone({ userInfo }) {
  return (
    <div className="content-stretch flex gap-[12px] items-center relative shrink-0">
      <div className="bg-gradient-to-b content-stretch flex from-[#f9dbaf] items-center p-[4px] relative rounded-[99px] shrink-0 size-[48px] to-[rgba(255,214,174,0)]">
        <div
          aria-hidden
          className="absolute border border-[#f7b27a] border-solid inset-0 pointer-events-none rounded-[99px]"
        />
        <div
          className="relative shrink-0 size-[40px]"
          data-name="solar:phone-bold"
        >
          <div
            className="absolute inset-[16.67%_12.5%_12.5%_12.5%]"
            data-name="Vector"
          >
            <svg
              className="absolute block inset-0 size-full"
              fill="none"
              preserveAspectRatio="none"
              viewBox="0 0 30.0002 28.3331"
            >
              <path
                d={svgPaths.p2608d180}
                fill="var(--fill-0, #EF6820)"
                id="Vector"
              />
            </svg>
          </div>
        </div>
      </div>
      <p className="[word-break:break-word] font-['Inter:Semi_Bold',sans-serif] font-semibold leading-none not-italic relative shrink-0 text-[#713b12] text-[28px] whitespace-nowrap">
        {userInfo?.isdn}
      </p>
    </div>
  );
}

function ProfileInfo({
  fileList,
  handlePreview,
  handleOpenUpload,
  valueName,
  setOpenUpdateName,
  userInfo,
  handleDelete,
  isMaster,
}) {
  return (
    <div className="content-stretch flex gap-[32px] items-center relative shrink-0 w-full">
      <Avatar
        fileList={fileList}
        handlePreview={handlePreview}
        handleOpenUpload={handleOpenUpload}
        handleDelete={handleDelete}
      />
      <div className="content-stretch flex flex-[1_0_0] flex-col gap-[16px] items-start min-w-px relative">
        <ProfileInfoHeader
          valueName={valueName}
          setOpenUpdateName={setOpenUpdateName}
        />
        {IS_UPDATE_VERSION_3_PROJECT &&
          <SDMaster isMaster={isMaster} />
        }
        <ProfilePhone userInfo={userInfo} />
      </div>
    </div>
  );
}

function StatItem({ image, number, text }) {
  return (
    <div className="content-stretch flex flex-[1_0_0] flex-col gap-[20px] items-center justify-center min-w-px relative">
      <div className="flex items-center justify-center relative shrink-0 size-[80.243px]">
        <div className="-scale-y-100 flex-none rotate-[179.83deg]">
          <div className="relative size-[80px]" data-name="image 395">
            <img
              alt=""
              className="absolute block inset-0 max-w-none size-full"
              height="80"
              src={image}
              width="80"
            />
          </div>
        </div>
      </div>
      <div className="[word-break:break-word] content-stretch flex flex-col gap-[8px] items-center justify-center leading-none not-italic relative shrink-0 text-[#713b12] whitespace-nowrap">
        <p className="font-['Inter:Bold',sans-serif] font-bold relative shrink-0 text-[36px]">
          {formatDataNumberToen(number)}
        </p>
        <p className="font-['Inter:Semi_Bold',sans-serif] font-semibold relative shrink-0 text-[28px]">
          {text}
        </p>
      </div>
    </div>
  );
}

function StatCoint({ dataSpinUserMini }) {
  const { t } = useTranslation();

  const coins =
    (dataSpinUserMini?.spin_left ?? 0) + (dataSpinUserMini?.spin_left_free ?? 0) + (dataSpinUserMini?.spin_left_super ?? 0)

  return (
    <div className="content-stretch flex flex-[1_0_0] flex-col gap-[20px] items-center justify-center min-w-px relative">
      <div
        className="pointer-events-none relative rounded-[11427.43px] shrink-0 size-[80px]"
        data-name="image 362"
      >
        <div className="absolute inset-0 overflow-hidden rounded-full">
          <img
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
            src={imgImage362}
          />
        </div>
        {/* <div
          aria-hidden
          className="absolute border-[#eb7710] border-[2.286px] border-solid inset-[-1.143px] rounded-[11428.573px]"
        /> */}
      </div>
      <div className="[word-break:break-word] content-stretch flex flex-col gap-[8px] items-center justify-center leading-none not-italic relative shrink-0 text-[#713b12] whitespace-nowrap">
        <p className="font-['Inter:Bold',sans-serif] font-bold relative shrink-0 text-[36px]">
          {formatDataNumberToen(coins)}
        </p>
        <p className="font-['Inter:Semi_Bold',sans-serif] font-semibold relative shrink-0 text-[28px]">
          {t("coins")}
        </p>
      </div>
    </div>
  );
}

function ProfileCoint({ dataSpinUserMini, turn, totalPiece, loyaltyPoint }) {
  const { t } = useTranslation();
  return (
    <div className="drop-shadow-[0px_-1px_2px_white] h-[236.243px] relative rounded-[32px] shrink-0 w-full">
      <div
        aria-hidden
        className="absolute bg-[#fdcb92] inset-0 pointer-events-none rounded-[32px]"
      />
      <div className="flex flex-row items-center size-full">
        <div className="content-stretch flex gap-[18px] items-center px-[24px] py-[32px] relative size-full">
          <StatItem
            image={imgImage395}
            number={turn || 0}
            text={t("account_page.turns")}
          />
          {IS_UPDATE_VERSION_3_PROJECT && (
            <>
              <div className="h-full relative shrink-0 w-0">
                <div className="absolute inset-[0_-0.5px]">
                  <svg
                    className="block size-full"
                    fill="none"
                    preserveAspectRatio="none"
                    viewBox="0 0 1 172.243"
                  >
                    <path
                      d="M0.5 0V172.243"
                      id="Vector 11"
                      stroke="var(--stroke-0, #FEECD1)"
                    />
                  </svg>
                </div>
              </div>
              <StatItem
                image={imgImage529}
                number={loyaltyPoint?.balance ?? 0}
                text={t("shwe_journey.LP")}
              />
            </>
          )}

          <div className="h-full relative shrink-0 w-0">
            <div className="absolute inset-[0_-0.5px]">
              <svg
                className="block size-full"
                fill="none"
                preserveAspectRatio="none"
                viewBox="0 0 1 172.243"
              >
                <path
                  d="M0.5 0V172.243"
                  id="Vector 11"
                  stroke="var(--stroke-0, #FEECD1)"
                />
              </svg>
            </div>
          </div>
          <StatItem
            image={imgImage441}
            number={totalPiece || 0}
            text={t("pieces")}
          />
          <div className="h-full relative shrink-0 w-0">
            <div className="absolute inset-[0_-0.5px]">
              <svg
                className="block size-full"
                fill="none"
                preserveAspectRatio="none"
                viewBox="0 0 1 172.243"
              >
                <path
                  d="M0.5 0V172.243"
                  id="Vector 11"
                  stroke="var(--stroke-0, #FEECD1)"
                />
              </svg>
            </div>
          </div>
          <StatCoint dataSpinUserMini={dataSpinUserMini} />
        </div>
      </div>
      <div className="absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_0px_0px_7.1px_0px_rgba(226,169,118,0.6),inset_0px_3px_0px_0px_#f2ac7e]" />
    </div>
  );
}

function BodyProfile({
  fileList,
  handlePreview,
  handleOpenUpload,
  valueName,
  setOpenUpdateName,
  userInfo,
  dataSpinUserMini,
  loyaltyPoint,
  turn,
  totalPiece,
  handleDelete,
  isMaster,
}) {
  return (
    <div className="relative shrink-0 w-full">
      <div className="content-stretch flex flex-col gap-[24px] items-start p-[44px] relative size-full">
        <ContainerProfile />
        <ProfileInfo
          fileList={fileList}
          handlePreview={handlePreview}
          handleOpenUpload={handleOpenUpload}
          valueName={valueName}
          setOpenUpdateName={setOpenUpdateName}
          userInfo={userInfo}
          handleDelete={handleDelete}
          isMaster={isMaster}
        />
        <ProfileCoint
          dataSpinUserMini={dataSpinUserMini}
          loyaltyPoint={loyaltyPoint}
          turn={turn}
          userInfo={userInfo}
          totalPiece={totalPiece}
        />
      </div>
    </div>
  );
}

function BodySettingContainer() {
  return (
    <div className="-translate-x-1/2 absolute bottom-0 content-stretch flex flex-col items-start left-1/2 top-0 w-[816px]">
      <div
        className="aspect-[816/81] relative shrink-0 w-full"
        data-name="image 524"
      >
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <img
            alt=""
            className="absolute h-[767.97%] left-[-7.14%] max-w-none top-[-125.25%] w-[114.29%]"
            src={imgImage524}
          />
        </div>
      </div>
      <div
        className="flex-[1_0_0] min-h-px relative w-full"
        data-name="image 526"
      >
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <img
            alt=""
            className="absolute h-[272.83%] left-[-7.14%] max-w-none top-[-80.02%] w-[114.29%]"
            src={imgImage524}
          />
        </div>
      </div>
      <div
        className="aspect-[816/81] relative shrink-0 w-full"
        data-name="image 525"
      >
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <img
            alt=""
            className="absolute h-[767.97%] left-[-7.14%] max-w-none top-[-506.73%] w-[114.29%]"
            src={imgImage524}
          />
        </div>
      </div>
    </div>
  );
}

function ItemSettingLanguage() {
  const { i18n, t } = useTranslation();
  const [language, setLanguage] = useState(
    localStorage.getItem("language") || "my",
  );

  const languages = [
    {
      value: "en",
      label: "English",
      flag: imgUS,
    },
    {
      value: "my",
      label: "Burmese",
      flag: imgMM,
    },
  ];

  const current =
    languages.find((item) => item.value === i18n.language) || languages[1];

  const handleChangeLanguage = (lang) => {
    setLanguage(lang);
    i18n.changeLanguage(lang);
    localStorage.setItem("language", lang);
  };

  return (
    <div className="content-stretch flex gap-[16px] items-center relative shrink-0 w-full">
      <div
        className="relative shrink-0 size-[48px]"
        data-name="solar:global-bold"
      >
        <div
          className="absolute bottom-[8.33%] left-[8.45%] right-1/2 top-[8.33%]"
          data-name="Vector"
        >
          <svg
            className="absolute block inset-0 size-full"
            fill="none"
            preserveAspectRatio="none"
            viewBox="0 0 19.944 40"
          >
            <path
              clipRule="evenodd"
              d={svgPaths.p15a59700}
              fill="var(--fill-0, #E04F16)"
              fillRule="evenodd"
              id="Vector"
            />
          </svg>
        </div>
        <div className="absolute inset-[14.15%_35.8%]" data-name="Vector">
          <svg
            className="absolute block inset-0 size-full"
            fill="none"
            preserveAspectRatio="none"
            viewBox="0 0 13.628 34.42"
          >
            <path
              d={svgPaths.p1e272600}
              fill="var(--fill-0, #E04F16)"
              id="Vector"
            />
          </svg>
        </div>
        <div
          className="absolute bottom-[8.33%] left-1/2 right-[8.45%] top-[8.33%]"
          data-name="Vector"
        >
          <svg
            className="absolute block inset-0 size-full"
            fill="none"
            preserveAspectRatio="none"
            viewBox="0 0 19.944 40"
          >
            <path
              d={svgPaths.p233bf272}
              fill="var(--fill-0, #E04F16)"
              id="Vector"
            />
          </svg>
        </div>
      </div>
      <p className="[word-break:break-word] flex-[1_0_0] font-['Inter:Semi_Bold',sans-serif] font-semibold leading-none min-w-px not-italic relative text-[#713b12] text-[36px]">
        {t("language")}
      </p>

      <DropdownMenu.Root>
        <DropdownMenu.Trigger asChild>
          <span className="flex gap-[16px] items-center relative shrink-0  btn-click-active">
            <p className="[word-break:break-word] font-['Inter:Semi_Bold',sans-serif] font-semibold leading-none not-italic relative shrink-0 text-[#713b12] text-[36px] whitespace-nowrap">
              {current.label}
            </p>
            <div
              className="relative shrink-0 size-[32px]"
              data-name="solar:alt-arrow-right-linear"
            >
              <div className="absolute inset-[20.83%_37.5%]" data-name="Vector">
                <div className="absolute inset-[-10.71%_-25%]">
                  <svg
                    className="block size-full"
                    fill="none"
                    preserveAspectRatio="none"
                    viewBox="0 0 12 22.6667"
                  >
                    <path
                      d={svgPaths.p12a961c0}
                      id="Vector"
                      stroke="var(--stroke-0, #A15C07)"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="4"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </span>
        </DropdownMenu.Trigger>

        <DropdownMenu.Portal>
          <DropdownMenu.Content
            sideOffset={8}
            align="end"
            className="min-w-[220px] rounded-2xl bg-[#FEFBF2] p-2 border border-[#F5D8A6] shadow-xl"
          >
            {languages.map((item) => (
              <DropdownMenu.Item
                key={item.value}
                onSelect={() => handleChangeLanguage(item.value)}
                className="
          flex items-center justify-between
          rounded-xl px-4 py-3
          cursor-pointer outline-none
          transition-colors
          data-[highlighted]:bg-[#F6F2EB]
        "
              >
                <div className="flex items-center gap-3">
                  <img
                    src={item.flag}
                    alt={item.label}
                    className="w-7 h-7 rounded-full object-cover"
                  />

                  <span className="text-[18px] font-semibold text-[#713B12]">
                    {item.label}
                  </span>
                </div>

                {language === item.value && (
                  <CheckIcon className="w-6 h-6 text-[#EF6820]" />
                )}
              </DropdownMenu.Item>
            ))}
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      </DropdownMenu.Root>
    </div>
  );
}

function Button() {
  return (
    <div
      className="relative rounded-[21762.529px] shadow-[0px_2.176px_6.529px_0px_rgba(10,13,18,0.1),0px_2.176px_4.353px_-2.176px_rgba(10,13,18,0.1)] shrink-0 size-[34.824px]"
      style={{
        backgroundImage:
          "linear-gradient(90deg, rgb(254, 251, 232) 0%, rgb(254, 251, 232) 100%), linear-gradient(90deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 100%)",
      }}
      data-name="Button"
    />
  );
}

function ToggleBase({ isOnMussic = false, setIsOnMussic = () => { } }) {
  const { t } = useTranslation();
  return (
    <div
      onClick={() => setIsOnMussic(!isOnMussic)}
      className="flex flex-row items-center self-stretch cursor-pointer"
    >
      <div
        className={`h-full relative rounded-[21762.529px] shrink-0 w-[120px] transition-all duration-300 ${!isOnMussic && "bg-[#D8D8D8]"
          }`}
        style={
          isOnMussic
            ? {
              backgroundImage:
                "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 120 55' xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='none'><rect x='0' y='0' height='100%' width='100%' fill='url(%23grad)' opacity='1'/><defs><radialGradient id='grad' gradientUnits='userSpaceOnUse' cx='0' cy='0' r='10' gradientTransform='matrix(-7.0899e-15 4.5558 -7.3404 2.809e-15 60.067 2.5972)'><stop stop-color='rgba(255,201,85,1)' offset='0'/><stop stop-color='rgba(252,144,57,1)' offset='0.5'/><stop stop-color='rgba(250,115,43,1)' offset='0.75'/><stop stop-color='rgba(248,86,29,1)' offset='1'/></radialGradient></defs></svg>\")",
            }
            : {}
        }
      >
        <div className="flex items-center overflow-hidden rounded-[inherit] size-full px-[12px] py-[8px] relative h-[53px]">
          <p
            className={`font-['Inter:Bold',sans-serif] font-bold text-[24px] tracking-[0.32px] transition-all duration-300 ${isOnMussic
              ? "text-[#fefbe8]"
              : "text-[#8A8A8A] absolute right-[18px]"
              }`}
          >
            {isOnMussic ? t("on") : t("off")}
          </p>

          <div
            className={`absolute top-1/2 -translate-y-1/2 transition-all duration-300 ease-out ${isOnMussic ? "right-[8px]" : "left-[8px]"
              }`}
          >
            <Button />
          </div>
        </div>

        <div
          aria-hidden
          className="absolute border-2 border-[#fff0aa] border-solid inset-0 pointer-events-none rounded-[21762.529px]"
        />
      </div>
    </div>
  );
}

function ItemSettingSound({ isOnMussic = false, setIsOnMussic = () => { } }) {
  const { t } = useTranslation();
  return (
    <div className="content-stretch flex gap-[16px] items-center relative shrink-0 w-full">
      <div
        className="relative shrink-0 size-[48px]"
        data-name="solar:volume-small-bold"
      >
        <div
          className="absolute inset-[16.67%_27.5%_16.67%_12.5%]"
          data-name="Vector"
        >
          <svg
            className="absolute block inset-0 size-full"
            fill="none"
            preserveAspectRatio="none"
            viewBox="0 0 28.8002 32.0014"
          >
            <path
              d={svgPaths.p110ec6c0}
              fill="var(--fill-0, #E04F16)"
              id="Vector"
            />
          </svg>
        </div>
        <div
          className="absolute inset-[34.68%_12.5%_34.67%_79.5%]"
          data-name="Vector"
        >
          <svg
            className="absolute block inset-0 size-full"
            fill="none"
            preserveAspectRatio="none"
            viewBox="0 0 3.84049 14.711"
          >
            <path
              clipRule="evenodd"
              d={svgPaths.p20bff780}
              fill="var(--fill-0, #E04F16)"
              fillRule="evenodd"
              id="Vector"
            />
          </svg>
        </div>
      </div>
      <p className="[word-break:break-word] flex-[1_0_0] font-['Inter:Semi_Bold',sans-serif] font-semibold leading-none min-w-px not-italic relative text-[#713b12] text-[36px]">
        {t("sound_music")}
      </p>
      <ToggleBase isOnMussic={isOnMussic} setIsOnMussic={setIsOnMussic} />
    </div>
  );
}

function ItemSetting({ icon, title, handleClick }) {
  return (
    <div
      onClick={handleClick}
      className="cursor-pointer content-stretch flex gap-[16px] items-center relative shrink-0 w-full"
    >
      <div
        className="relative shrink-0 size-[48px]"
        data-name="solar:history-bold"
      >
        <div
          className="absolute inset-[9.37%_9.37%_9.38%_9.37%]"
          data-name="Vector"
        >
          {icon}
        </div>
      </div>
      <p className="[word-break:break-word] flex-[1_0_0] font-['Inter:Semi_Bold',sans-serif] font-semibold leading-none min-w-px not-italic relative text-[#713b12] text-[36px]">
        {title}
      </p>
      <div
        className="relative shrink-0 size-[32px]"
        data-name="solar:alt-arrow-right-linear"
      >
        <div className="absolute inset-[20.83%_37.5%]" data-name="Vector">
          <div className="absolute inset-[-10.71%_-25%]">
            <svg
              className="block size-full"
              fill="none"
              preserveAspectRatio="none"
              viewBox="0 0 12 22.6667"
            >
              <path
                d={svgPaths.p12a961c0}
                id="Vector"
                stroke="var(--stroke-0, #A15C07)"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="4"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}

function ItemLogout({ setShowModalLogout }) {
  const { t } = useTranslation();
  return (
    <div
      className="btn-click-active content-stretch flex gap-[16px] items-center relative shrink-0 w-full"
      onClick={() => setShowModalLogout(true)}
    >
      <div
        className="relative shrink-0 size-[48px]"
        data-name="solar:logout-2-bold"
      >
        <div
          className="absolute inset-[34.37%_32.81%_34.37%_6.77%]"
          data-name="Vector"
        >
          <svg
            className="absolute block inset-0 size-full"
            fill="none"
            preserveAspectRatio="none"
            viewBox="0 0 29.0011 15.0015"
          >
            <path
              clipRule="evenodd"
              d={svgPaths.p3642ca00}
              fill="var(--fill-0, #E04F16)"
              fillRule="evenodd"
              id="Vector"
            />
          </svg>
        </div>
        <div
          className="absolute inset-[8.33%_6.77%_8.33%_39.06%]"
          data-name="Vector"
        >
          <svg
            className="absolute block inset-0 size-full"
            fill="none"
            preserveAspectRatio="none"
            viewBox="0 0 26 40"
          >
            <path
              d={svgPaths.p37921c00}
              fill="var(--fill-0, #E04F16)"
              id="Vector"
            />
          </svg>
        </div>
      </div>
      <p className="[word-break:break-word] flex-[1_0_0] font-['Inter:Semi_Bold',sans-serif] font-semibold leading-none min-w-px not-italic relative text-[#713b12] text-[36px]">
        {t("account_page.logout")}
      </p>
    </div>
  );
}

function BorderBottom() {
  return (
    <div className="h-0 relative shrink-0 w-full">
      <div className="absolute inset-[-0.5px_-0.21%_-2.5px_-0.21%]">
        <svg
          className="block size-full"
          fill="none"
          preserveAspectRatio="none"
          viewBox="0 0 731 3"
        >
          <g filter="url(#filter0_d_7_827)" id="Vector 14">
            <path
              d="M1.5 0.5H729.5"
              stroke="var(--stroke-0, #F7B27A)"
              strokeLinecap="round"
            />
          </g>
          <defs>
            <filter
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
              height="3"
              id="filter0_d_7_827"
              width="731"
              x="0"
              y="0"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              />
              <feOffset dy="1" />
              <feGaussianBlur stdDeviation="0.5" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
              />
              <feBlend
                in2="BackgroundImageFix"
                mode="normal"
                result="effect1_dropShadow_7_827"
              />
              <feBlend
                in="SourceGraphic"
                in2="effect1_dropShadow_7_827"
                mode="normal"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      </div>
    </div>
  );
}

function BodySetting({ isOnMussic, setIsOnMussic, setShowModalLogout }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className="relative shrink-0 w-full">
      <div className="content-stretch flex flex-col gap-[28px] items-start p-[44px] relative size-full">
        <BodySettingContainer />
        {IS_UPDATE_VERSION_3_PROJECT && (
          <>
            <ItemSettingLanguage />
            <BorderBottom />
            <ItemSettingSound
              isOnMussic={isOnMussic}
              setIsOnMussic={setIsOnMussic}
            />
            <BorderBottom />
            <ItemSetting
              icon={
                <svg
                  className="absolute block inset-0 size-full"
                  fill="none"
                  preserveAspectRatio="none"
                  viewBox="0 0 39.0009 38.9996"
                >
                  <path
                    clipRule="evenodd"
                    d={svgPaths.p2bdba274}
                    fill="var(--fill-0, #E04F16)"
                    fillRule="evenodd"
                    id="Vector"
                  />
                </svg>
              }
              title={t("home.hero.history")}
              handleClick={() => {
                navigate(PATH.HISTORY);
              }}
            />
            <BorderBottom />
          </>
        )}

        <ItemSetting
          icon={
            <svg
              className="absolute block inset-0 size-full"
              fill="none"
              preserveAspectRatio="none"
              viewBox="0 0 40 40"
            >
              <path
                d={svgPaths.p19f7a930}
                fill="var(--fill-0, #E04F16)"
                id="Vector"
              />
            </svg>
          }
          title={t("help_center")}
          handleClick={() => {
            navigate(PATH.HELP_CENTER);
          }}
        />
        <BorderBottom />
        <ItemSetting
          icon={
            <svg
              className="absolute block inset-0 size-full"
              fill="none"
              preserveAspectRatio="none"
              viewBox="0 0 40 41.5"
            >
              <path
                clipRule="evenodd"
                d={svgPaths.p1d98300}
                fill="var(--fill-0, #E04F16)"
                fillRule="evenodd"
                id="Vector"
              />
            </svg>
          }
          title={t("account_page.change_password")}
          handleClick={() => {
            navigate(PATH.CHANGE_PASSWORD);
          }}
        />
        <BorderBottom />
        <ItemLogout setShowModalLogout={setShowModalLogout} />
      </div>
    </div>
  );
}

function Main({
  isOnMussic,
  setIsOnMussic,
  fileList,
  handlePreview,
  setShowModalLogout,
  handleOpenUpload,
  valueName,
  setOpenUpdateName,
  userInfo,
  dataSpinUserMini,
  loyaltyPoint,
  turn,
  totalPiece,
  handleDelete,
  isMaster,
}) {
  const { t } = useTranslation();

  return (
    <div className="absolute content-stretch flex flex-col items-start left-0 top-0 w-[880px]">
      <Headers
        title={t("pages.profileSetting")}
        className="w-full gap-[24px] px-[32px] py-[24px] pt-[60px]"
      />
      <div className="relative shrink-0 w-full">
        <div className="content-stretch flex flex-col gap-[32px] items-start p-[32px] relative size-full">
          <BodyProfile
            fileList={fileList}
            handlePreview={handlePreview}
            handleOpenUpload={handleOpenUpload}
            valueName={valueName}
            setOpenUpdateName={setOpenUpdateName}
            userInfo={userInfo}
            dataSpinUserMini={dataSpinUserMini}
            loyaltyPoint={loyaltyPoint}
            turn={turn}
            totalPiece={totalPiece}
            handleDelete={handleDelete}
            isMaster={isMaster}
          />
          <BodySetting
            isOnMussic={isOnMussic}
            setIsOnMussic={setIsOnMussic}
            setShowModalLogout={setShowModalLogout}
          />
        </div>
      </div>
    </div>
  );
}

export default function ComponentAccount({
  isOnMussic,
  setIsOnMussic,
  fileList,
  handlePreview,
  setShowModalLogout,
  handleOpenUpload,
  valueName,
  setOpenUpdateName,
  userInfo,
  dataSpinUserMini,
  loyaltyPoint,
  turn,
  totalPiece,
  handleDelete,
  isMaster,
}) {
  return (
    <div
      className="relative size-full"
      style={{
        // backgroundImage:
        //   "linear-gradient(rgb(252, 238, 210) 0%, rgb(253, 210, 156) 100%), linear-gradient(90deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 100%)",
      }}
      data-name="Profile & Setting"
    >
      <div
        className="-translate-x-1/2 absolute h-[520px] left-1/2 top-[-135px] w-[924px]"
        data-name="image 521"
      >
        <div aria-hidden className="absolute inset-0 pointer-events-none">
          <img
            alt=""
            className="absolute max-w-none object-cover size-full -mt-1"
            src={imgImage521}
          />
          <div className="absolute bg-gradient-to-b from-[65.577%] from-[rgba(252,232,199,0)] inset-0 to-[#fce8c7] to-[97.788%]" />
        </div>
      </div>
      <Main
        isOnMussic={isOnMussic}
        setIsOnMussic={setIsOnMussic}
        fileList={fileList}
        handlePreview={handlePreview}
        setShowModalLogout={setShowModalLogout}
        handleOpenUpload={handleOpenUpload}
        valueName={valueName}
        setOpenUpdateName={setOpenUpdateName}
        userInfo={userInfo}
        dataSpinUserMini={dataSpinUserMini}
        loyaltyPoint={loyaltyPoint}
        turn={turn}
        totalPiece={totalPiece}
        handleDelete={handleDelete}
        isMaster={isMaster}
      />
    </div>
  );
}
